import { createPersistor, createStore } from '@/Store';

export const store = createStore();
export const persistor = createPersistor(store);
